import { Instance, types } from "mobx-state-tree"

export const ClientModel = types.model("ClientModel").props({
  id: types.identifierNumber,
  name: types.string
})

export interface Client extends Instance<typeof ClientModel> {}